import { render } from "./KeyboardIconsComponent.vue?vue&type=template&id=0c98ded6&scoped=true"
import script from "./KeyboardIconsComponent.vue?vue&type=script&lang=js"
export * from "./KeyboardIconsComponent.vue?vue&type=script&lang=js"

import "./KeyboardIconsComponent.vue?vue&type=style&index=0&id=0c98ded6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c98ded6"]])

export default __exports__